import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'referralFacilitatorStatus',
})
export class ReferralFacilitatorStatusPipe implements PipeTransform {
    transform(referralCode: string) {
        if (referralCode == null) {
            return '';
        }

        switch (referralCode) {
            case 'M': // Finished by supervisor with answer
                return 'Finished by supervisor';
            case 'I': // Finished by supervisor with no info
                return 'No information available';
            case 'N': // Supervisor needs time approval
                return 'Needs Time Approval';
            default:
                return '';
        }
    }
}
